<template>
	<div>
		<FallBack
			v-if="error"
			:message="error"
			transparentBackground
			iconStyle="fal"
			icon="exclamation-triangle"
		/>
		<div v-else>
			<p v-if="singleContact" class="reactivate-modal-text">
				Are you sure you want to proceed with marking this contact
				active?
			</p>
			<p v-else class="reactivate-modal-text">
				You have selected ({{ selectedContacts }}) contacts. Are you
				sure you want to proceed with marking them active?
			</p>
			<OverviewModalFooter
				:success="success"
				:waiting="waiting"
				:primaryButtonName="'Save'"
				isSaveModal
				@handleClick="handleReactivateContactAction"
				@close="$emit('handleClose')"
			/>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import leadsService from '@/services/contacts/leads-service.js';
import FallBack from '@/components/global/FallBack.vue';
import OverviewModalFooter from './OverviewModalFooter.vue';

export default {
	name: 'ReactivateContact',
	components: {
		FallBack,
		OverviewModalFooter,
	},
	data() {
		return {
			waiting: false,
			success: false,
			error: null,
		};
	},
	props: {
		companyIds: Array,
		leadId: Number,
		selectAllMode: Boolean,
		selectedLeadIds: Array,
	},
	computed: {
		...mapState({
			filters: (state) => state.ccContacts.filters,
			selectedBrokers: (state) =>
				state.clientConnectV2.selectedContactsIds,
			totalCount: (state) => state.ccContacts.leads.totalCount,
		}),
		contactsToActivate() {
			if (this.leadId) return [this.leadId];
			return this.selectedLeadIds;
		},
		currentFilters() {
			const [entityId, brokerIds] = this.companyIds;
			let filters = {
				activeInd: false,
				data: {
					...this.filters,
					entityId,
				},
			};
			filters.searchTerm = filters.data.searchTerm;
			delete filters.data.searchTerm;

			if (this.selectedBrokers.length === 0) {
				filters.data.contactsIds = brokerIds;
			} else {
				filters.data.contactsIds = this.selectedBrokers;
			}
			return filters;
		},
		selectAll() {
			if (this.leadId) return false;
			return this.selectAllMode;
		},
		selectedContacts() {
			if (this.selectAllMode) {
				return this.totalCount - this.selectedLeadIds.length;
			}
			return this.selectedLeadIds.length;
		},
		singleContact() {
			return this.leadId || this.selectedContacts === 1;
		},
	},
	methods: {
		...mapActions(['removeContacts']),
		async handleReactivateContactAction() {
			let payload = {};

			if (!this.selectAll) {
				payload = {
					leadIds: this.contactsToActivate,
					activeInd: true,
					selectAllMode: this.selectAll,
				};
			} else {
				payload = {
					leadIds: this.contactsToActivate,
					activeInd: true,
					selectAllMode: this.selectAll,
					filters: this.currentFilters,
				};
			}

			this.waiting = true;
			try {
				await leadsService.updateActiveStatus(payload);
				this.success = true;
				setTimeout(() => {
					if (this.selectedLeadIds && this.leadId) {
						this.$emit('filterLeadId');
					} else {
						this.$emit('clearLeadIds');
					}
					this.removeContacts({
						leadIds: this.contactsToActivate,
						selectAll: this.selectAll,
					});
					this.$emit('handleClose');
					this.success = false;
				}, 1500);
			} catch (error) {
				this.error = error.message;
			}
			this.waiting = false;
		},
	},
};
</script>

<style lang="scss" scoped>
p.reactivate-modal-text {
	padding: 20px;
	margin: 0;
}
</style>
